// src/router/notasFiscaisSaida.js
// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

// Registrado automaticamente pelo auto-glob em src/router/index.js

const notasFiscaisSaidaBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Notas fiscais de saída',
    to: 'NotasFiscaisSaidaList'
  }
]

export default [
  {
    path: '/notas-fiscais-saida',
    name: 'NotasFiscaisSaidaList',
    component: () => import('@/views/Financeiro/NotasFiscaisSaida/ListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Notas fiscais de saída',
      breadcrumb: notasFiscaisSaidaBreadCrumb
    },
  }
];
